"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DateOnly_1 = tslib_1.__importDefault(require("./DateOnly"));
const TimeOnly_1 = tslib_1.__importDefault(require("./TimeOnly"));
class DateAndTime {
    static createDateAndTimeFromDate(date, time) {
        if (date) {
            return new DateAndTime(DateOnly_1.default.createFromDate(date), time);
        }
        else {
            return null;
        }
    }
    static create(date) {
        if (date) {
            return new DateAndTime(DateOnly_1.default.createFromDate(date), TimeOnly_1.default.createFromDate(date));
        }
        else {
            return null;
        }
    }
    static createDateOnly(date) {
        if (date) {
            return new DateAndTime(DateOnly_1.default.createFromDate(date), null);
        }
        else {
            return null;
        }
    }
    constructor(date, time) {
        this.date = date;
        this.time = time;
    }
    getDateOnly() {
        return this.date;
    }
    getTimeOnly() {
        return this.time;
    }
    getDate() {
        if (!this.date) {
            return null;
        }
        else if (!this.time) {
            return new Date(this.date.getYear(), this.date.getMonth(), this.date.getDate());
        }
        else {
            return new Date(this.date.getYear(), this.date.getMonth(), this.date.getDate(), this.time.getHour(), this.time.getMinute());
        }
    }
    hasTime() {
        return !!this.time;
    }
}
exports.default = DateAndTime;
//# sourceMappingURL=DateAndTime.js.map